module.exports = __webpack_public_path__ + "static/media/013_GF Step 3 MPA @2x.01bf48bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/farmers/013_GF Step 3 MPA @2x.png
// module id = 425
// module chunks = 0